module.exports = __webpack_public_path__ + "static/media/blank_1.5ca40c82.png";